/* ============================================================
   TTH VISUAL SEARCH — standalone page logic (v5, auto-focus)
   Upload as: assets/tth-visual-search.js
   Used by: sections/visual-search.liquid

   CHANGES from v4:
   - On upload, immediately calls /similar-auto (full photo, no crop
     needed) and shows results right away.
   - The crop box appears pre-positioned at whatever region the server
     auto-detected as "most tile-like" — shown as a starting point,
     not a required step.
   - "Search This Crop" button still works exactly as before (manual
     override via /similar), for anyone who wants to refine further.
   ============================================================ */
(function() {
  'use strict';
  try { console.log('TTH Visual Search page build: 2026-07-12-v5-auto-focus'); } catch (e) {}

  var VISUAL_SEARCH_BASE = 'https://tth-visual-search-trial.onrender.com';
  var STOREFRONT_TOKEN = '150dd526cb53fa17928fca8d4b4cc58e';
  var MIN_CROP_SIZE = 40;
  var DEFAULT_CROP_PCT = 0.55; // fallback if auto-detect ever fails
  var MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB, matches what the UI promises

  function esc(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function mfVal(mf) {
    return (mf && mf.value) ? String(mf.value).toLowerCase().trim() : '';
  }

  function computePricePerSqft(n) {
    try {
      var boxPrice = n.priceRange && n.priceRange.minVariantPrice ? parseFloat(n.priceRange.minVariantPrice.amount) : NaN;
      if (isNaN(boxPrice) || boxPrice <= 0) return null;
      var areaBox = n.areaPerBox && n.areaPerBox.value ? parseFloat(n.areaPerBox.value) : NaN;
      if (isNaN(areaBox) || areaBox <= 0) return null;
      var perSqft = boxPrice / areaBox;
      if (perSqft < 20 || perSqft > 500) return null;
      return perSqft;
    } catch (e) { return null; }
  }

  window.TTHVisualSearch = {
    init: function(opts) {
      var shopDomain = opts.shopDomain;
      var dropzone = document.getElementById(opts.dropzoneId);
      var browseBtn = document.getElementById(opts.browseBtnId);
      var fileInput = document.getElementById(opts.fileInputId);
      var heading = document.getElementById(opts.headingId);
      var previewWrap = document.getElementById(opts.previewWrapId);
      var previewImg = document.getElementById(opts.previewId);
      var cropBox = document.getElementById(opts.cropBoxId);
      var searchBtn = document.getElementById(opts.searchBtnId);
      var reuploadBtn = document.getElementById(opts.reuploadBtnId);
      var statusEl = document.getElementById(opts.statusId);
      var resultsEl = document.getElementById(opts.resultsId);

      var cropState = { x: 0, y: 0, size: 0 };
      var drag = null;
      var lastWindowWidth = window.innerWidth;
      var loadingInterval = null; // rotates status text while a search is in flight
      var currentFile = null;
      var searchGeneration = 0; // bumped on every search; a response only
                                 // gets rendered if it's still the latest
                                 // one requested — fixes the case where a
                                 // slow auto-search finishes AFTER a manual
                                 // "Find" click and wipes out its results.
      var userAdjustedCrop = false; // true once the person has actually
                                     // dragged/resized the crop box — Find
                                     // uses their exact crop when true,
                                     // otherwise auto-detects on the full photo.

      // ---- build the 4 corner resize handles once ----
      var HANDLE_SIZE = 18;
      var handles = {};
      ['tl', 'tr', 'bl', 'br'].forEach(function(corner) {
        var h = document.createElement('div');
        h.className = 'tth-vs-handle tth-vs-handle-' + corner;
        h.style.cssText =
          'position:absolute;width:' + HANDLE_SIZE + 'px;height:' + HANDLE_SIZE + 'px;' +
          'background:#ff6b00;border:2px solid #fff;border-radius:50%;' +
          'box-shadow:0 1px 4px rgba(0,0,0,0.4);touch-action:none;' +
          (corner === 'tl' ? 'top:0;left:0;transform:translate(-50%,-50%);cursor:nwse-resize;' :
           corner === 'tr' ? 'top:0;right:0;transform:translate(50%,-50%);cursor:nesw-resize;' :
           corner === 'bl' ? 'bottom:0;left:0;transform:translate(-50%,50%);cursor:nesw-resize;' :
                              'bottom:0;right:0;transform:translate(50%,50%);cursor:nwse-resize;');
        cropBox.appendChild(h);
        handles[corner] = h;
      });
      if (cropBox) cropBox.style.touchAction = 'none';

      function clampToImage() {
        var wrapW = previewImg.clientWidth;
        var wrapH = previewImg.clientHeight;
        cropState.size = Math.max(MIN_CROP_SIZE, Math.min(cropState.size, Math.min(wrapW, wrapH)));
        cropState.x = Math.max(0, Math.min(cropState.x, wrapW - cropState.size));
        cropState.y = Math.max(0, Math.min(cropState.y, wrapH - cropState.size));
      }

      function render() {
        clampToImage();
        cropBox.style.left = cropState.x + 'px';
        cropBox.style.top = cropState.y + 'px';
        cropBox.style.width = cropState.size + 'px';
        cropBox.style.height = cropState.size + 'px';
      }

      function setCropFromFraction(xf, yf, wf, hf) {
        var wrapW = previewImg.clientWidth;
        var wrapH = previewImg.clientHeight;
        cropState.x = xf * wrapW;
        cropState.y = yf * wrapH;
        // Box is square in pixels; use width fraction against wrapW as the
        // basis (close enough since detected regions are already square
        // relative to the original photo's shorter side).
        cropState.size = wf * wrapW;
        render();
      }

      function resetCropToCenter() {
        var wrapW = previewImg.clientWidth;
        var wrapH = previewImg.clientHeight;
        cropState.size = Math.min(wrapW, wrapH) * DEFAULT_CROP_PCT;
        cropState.x = (wrapW - cropState.size) / 2;
        cropState.y = (wrapH - cropState.size) / 2;
        render();
      }

      function pointFromEvent(e) {
        if (e.touches && e.touches.length) return { x: e.touches[0].clientX, y: e.touches[0].clientY };
        if (e.changedTouches && e.changedTouches.length) return { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
        return { x: e.clientX, y: e.clientY };
      }

      function beginMove(e) {
        e.preventDefault();
        userAdjustedCrop = true;
        var p = pointFromEvent(e);
        drag = { mode: 'move', startPointerX: p.x, startPointerY: p.y, startX: cropState.x, startY: cropState.y };
      }

      function beginResize(corner, e) {
        e.preventDefault();
        e.stopPropagation();
        userAdjustedCrop = true;
        var anchorX = corner.indexOf('l') !== -1 ? cropState.x + cropState.size : cropState.x;
        var anchorY = corner.indexOf('t') !== -1 ? cropState.y + cropState.size : cropState.y;
        drag = { mode: 'resize', corner: corner, anchorX: anchorX, anchorY: anchorY };
      }

      function onPointerMove(e) {
        if (!drag) return;
        e.preventDefault();
        var p = pointFromEvent(e);
        var wrapW = previewImg.clientWidth;
        var wrapH = previewImg.clientHeight;

        if (drag.mode === 'move') {
          cropState.x = drag.startX + (p.x - drag.startPointerX);
          cropState.y = drag.startY + (p.y - drag.startPointerY);
          render();
        } else if (drag.mode === 'resize') {
          var rect = previewImg.getBoundingClientRect();
          var pointerX = p.x - rect.left;
          var pointerY = p.y - rect.top;
          var newSize = Math.max(MIN_CROP_SIZE, Math.max(Math.abs(pointerX - drag.anchorX), Math.abs(pointerY - drag.anchorY)));

          var maxSizeX = drag.corner.indexOf('l') !== -1 ? drag.anchorX : (wrapW - drag.anchorX);
          var maxSizeY = drag.corner.indexOf('t') !== -1 ? drag.anchorY : (wrapH - drag.anchorY);
          newSize = Math.min(newSize, maxSizeX, maxSizeY);

          cropState.size = newSize;
          cropState.x = drag.corner.indexOf('l') !== -1 ? drag.anchorX - newSize : drag.anchorX;
          cropState.y = drag.corner.indexOf('t') !== -1 ? drag.anchorY - newSize : drag.anchorY;
          render();
        }
      }

      function endDrag() { drag = null; }

      if (cropBox) {
        cropBox.addEventListener('mousedown', function(e) { if (e.target === cropBox) beginMove(e); });
        cropBox.addEventListener('touchstart', function(e) { if (e.target === cropBox) beginMove(e); }, { passive: false });
        Object.keys(handles).forEach(function(corner) {
          handles[corner].addEventListener('mousedown', function(e) { beginResize(corner, e); });
          handles[corner].addEventListener('touchstart', function(e) { beginResize(corner, e); }, { passive: false });
        });
        window.addEventListener('mousemove', onPointerMove);
        window.addEventListener('touchmove', onPointerMove, { passive: false });
        window.addEventListener('mouseup', endDrag);
        window.addEventListener('touchend', endDrag);
      }

      window.addEventListener('resize', function() {
        if (drag) return;
        var w = window.innerWidth;
        if (w === lastWindowWidth) return;
        lastWindowWidth = w;
        // Re-render at the same relative position/size rather than
        // re-centering, so a real rotation doesn't discard an auto-detected
        // or manually-adjusted crop.
        render();
      });

      function getCroppedBlob() {
        return new Promise(function(resolve) {
          var canvas = document.createElement('canvas');
          var outputSize = 512;
          canvas.width = outputSize;
          canvas.height = outputSize;
          var ctx = canvas.getContext('2d');
          var scaleX = previewImg.naturalWidth / previewImg.clientWidth;
          var scaleY = previewImg.naturalHeight / previewImg.clientHeight;
          var sx = cropState.x * scaleX;
          var sy = cropState.y * scaleY;
          var sSize = cropState.size * scaleX;
          ctx.drawImage(previewImg, sx, sy, sSize, sSize, 0, 0, outputSize, outputSize);
          canvas.toBlob(function(blob) { resolve(blob); }, 'image/jpeg', 0.9);
        });
      }

      function setStatus(text) {
        if (statusEl) statusEl.textContent = text;
      }

      // Search now takes a few seconds (CLIP scan + Claude actually looking
      // at the shortlist), so a few blinking dots leaves people guessing
      // whether anything's happening. This cycles through short status
      // lines instead, so it reads as "working," not "stuck."
      var LOADING_MESSAGES_AUTO = [
        'Scanning your photo for the tile...',
        'Comparing colors and patterns...',
        'Checking against the full catalog...',
        'Double-checking the closest matches...',
        'Almost there...'
      ];
      var LOADING_MESSAGES_MANUAL = [
        'Looking closely at your selected crop...',
        'Comparing textures and finishes...',
        'Ranking the closest matches...',
        'Almost there...'
      ];

      function startLoadingMessages(messages) {
        stopLoadingMessages();
        var i = 0;
        setStatus(messages[0]);
        loadingInterval = setInterval(function() {
          i = (i + 1) % messages.length;
          setStatus(messages[i]);
        }, 1700);
      }

      function stopLoadingMessages() {
        if (loadingInterval) {
          clearInterval(loadingInterval);
          loadingInterval = null;
        }
      }

      function scrollToResults() {
        // On mobile especially, results can land below the fold — without
        // this, someone could easily assume the search found nothing and
        // give up without ever scrolling down.
        if (statusEl) {
          statusEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      async function fetchProductsByHandles(handleList) {
        if (!handleList || !handleList.length) return [];
        var fields = 'title handle featuredImage { url } ' +
          'priceRange { minVariantPrice { amount } } ' +
          'areaPerBox: metafield(namespace: "custom", key: "area_covered_per_box_sqft_") { value } ' +
          'mfShortDesc: metafield(namespace: "custom", key: "short_description") { value }';
        var aliasParts = handleList.map(function(h, i) {
          var safe = String(h).replace(/["\\]/g, '');
          return 'p' + i + ': productByHandle(handle: "' + safe + '") { ' + fields + ' }';
        });
        var gql = JSON.stringify({ query: '{ ' + aliasParts.join(' ') + ' }' });
        try {
          var res = await fetch('https://' + shopDomain + '/api/2025-04/graphql.json', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN },
            body: gql
          });
          var data = await res.json();
          var out = [];
          if (data.data) {
            Object.keys(data.data).forEach(function(key) {
              var n = data.data[key];
              if (!n) return;
              n.shortDesc = mfVal(n.mfShortDesc);
              n.pricePerSqft = computePricePerSqft(n);
              out.push(n);
            });
          }
          return out;
        } catch (e) {
          console.error('fetchProductsByHandles error:', e);
          return [];
        }
      }

      function buildResultCard(product, score, searchId, position) {
        var title = esc(product.title);
        var handle = encodeURIComponent(product.handle);
        var imageHtml = '<div style="width:100%;aspect-ratio:1;background:#f4f4f4;border-radius:8px;"></div>';
        if (product.featuredImage && product.featuredImage.url) {
          var imgUrl = product.featuredImage.url;
          imgUrl += (imgUrl.indexOf('?') !== -1 ? '&' : '?') + 'width=400';
          imageHtml = '<img src="' + esc(imgUrl) + '" loading="lazy" style="width:100%;aspect-ratio:1;object-fit:cover;border-radius:8px;" alt="' + title + '">';
        }
        var priceHtml = '';
        if (product.pricePerSqft != null && !isNaN(product.pricePerSqft) && product.pricePerSqft > 0) {
          priceHtml = '<p style="font-size:13px;color:#1a1a1a;font-weight:600;margin:6px 0 2px;">\u20b9' + Math.round(product.pricePerSqft) + '/sqft</p>';
        }
        var matchPct = Math.round((score || 0) * 100);
        return '<a href="/products/' + handle + '" target="_blank" class="tth-vs-result-link" ' +
               'data-vs-handle="' + esc(product.handle) + '" data-vs-score="' + (score || 0) + '" ' +
               'data-vs-search-id="' + esc(searchId || '') + '" data-vs-position="' + (position || '') + '" ' +
               'style="text-decoration:none;color:inherit;display:block;">' +
               imageHtml +
               '<p style="font-size:14px;margin:8px 0 0;color:#1a1a1a;font-weight:500;">' + title + '</p>' +
               priceHtml +
               '<p style="font-size:11px;color:#ff6b00;margin:2px 0 0;">' + matchPct + '% visual match</p>' +
               '</a>';
      }

      // One listener for all result cards (they get replaced on every new
      // search, so attaching to each individually would leak listeners).
      // This is the real "did this search actually work" signal — logs
      // which product someone actually clicked through to, tied to the
      // exact search (via search_id) and where it sat in the list.
      if (resultsEl) {
        resultsEl.addEventListener('click', function(e) {
          var link = e.target.closest && e.target.closest('.tth-vs-result-link');
          if (!link) return;
          try {
            fetch(VISUAL_SEARCH_BASE + '/log-click', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                handle: link.getAttribute('data-vs-handle'),
                score: parseFloat(link.getAttribute('data-vs-score')) || 0,
                search_id: link.getAttribute('data-vs-search-id') || '',
                position: parseInt(link.getAttribute('data-vs-position'), 10) || ''
              })
            });
          } catch (err) {
            console.error('log-click failed:', err);
          }
          // Link already opens in a new tab (target="_blank"), so this
          // page never navigates away — no need to delay/block anything.
        });
      }

      async function renderResultsFromSearchResponse(data, statusPrefix, myGen) {
        // A newer search has started since this one began — discard this
        // stale response instead of letting it overwrite fresher results.
        if (myGen !== searchGeneration) return;
        stopLoadingMessages();

        var results = data.results || [];
        var searchId = data.search_id || '';
        if (!results.length) {
          setStatus('No similar tiles found. Try a different photo, or adjust the crop box.');
          return;
        }
        var topResults = results.slice(0, 12);
        var handleList = topResults.map(function(r) { return r.handle; });
        var products = await fetchProductsByHandles(handleList);
        if (myGen !== searchGeneration) return; // check again — this await took time too

        var scoreByHandle = {};
        topResults.forEach(function(r) { scoreByHandle[r.handle] = r.score; });

        var ordered = handleList
          .map(function(h) { return products.find(function(p) { return p.handle === h; }); })
          .filter(Boolean);

        if (!ordered.length) {
          setStatus('Found matches, but could not load their details. Please try again.');
          return;
        }

        setStatus(statusPrefix);
        resultsEl.innerHTML = ordered.map(function(p, i) {
          return '<div>' + buildResultCard(p, scoreByHandle[p.handle], searchId, i + 1) + '</div>';
        }).join('');
      }

      async function runAutoSearch(file) {
        var myGen = ++searchGeneration;
        resultsEl.innerHTML = '';
        startLoadingMessages(LOADING_MESSAGES_AUTO);
        console.log('[TTH Visual Search] Uploading original file for auto-search:', file.name, Math.round(file.size / 1024) + 'KB');
        try {
          var formData = new FormData();
          formData.append('file', file);
          var res = await fetch(VISUAL_SEARCH_BASE + '/similar-auto', { method: 'POST', body: formData });
          if (!res.ok) throw new Error('Service error: ' + res.status);
          var data = await res.json();
          if (myGen !== searchGeneration) return; // superseded while we were waiting on the network

          if (data.detected_region) {
            var r = data.detected_region;
            setCropFromFraction(r.x, r.y, r.width, r.height);
          } else {
            resetCropToCenter();
          }

          await renderResultsFromSearchResponse(data, 'Found matches \u2014 scroll down to see them, or adjust the box below to refine.', myGen);
        } catch (e) {
          if (myGen !== searchGeneration) return;
          stopLoadingMessages();
          setStatus('Auto-detection had a problem, but you can still crop manually below.');
          console.error('runAutoSearch error:', e);
          resetCropToCenter();
        }
      }

      async function runManualSearch() {
        var myGen = ++searchGeneration;
        startLoadingMessages(LOADING_MESSAGES_MANUAL);
        if (searchBtn) searchBtn.disabled = true;
        try {
          var blob = await getCroppedBlob();
          console.log('[TTH Visual Search] Uploading crop:', Math.round(blob.size / 1024) + 'KB',
            '— source photo natural size was', previewImg.naturalWidth + 'x' + previewImg.naturalHeight,
            '(display size was', previewImg.clientWidth + 'x' + previewImg.clientHeight + ')');
          var formData = new FormData();
          formData.append('file', blob, 'crop.jpg');
          var res = await fetch(VISUAL_SEARCH_BASE + '/similar', { method: 'POST', body: formData });
          if (!res.ok) throw new Error('Service error: ' + res.status);
          var data = await res.json();
          if (myGen !== searchGeneration) { if (searchBtn) searchBtn.disabled = false; return; }
          await renderResultsFromSearchResponse(data, 'Closest matches to your selected crop:', myGen);
          scrollToResults();
        } catch (e) {
          if (myGen === searchGeneration) {
            stopLoadingMessages();
            setStatus('Something went wrong searching by photo. Please try again.');
            scrollToResults();
          }
          console.error('runManualSearch error:', e);
        }
        if (searchBtn) searchBtn.disabled = false;
      }

      function handleFile(file) {
        if (!file) return;
        if (file.size > MAX_FILE_SIZE) {
          setStatus('That photo is a bit too large (max 10 MB) \u2014 try a smaller or more compressed version.');
          return;
        }
        currentFile = file;
        userAdjustedCrop = false;
        searchGeneration++; // invalidate any search still in flight for a previous photo
        resultsEl.innerHTML = '';
        setStatus('');
        var reader = new FileReader();
        reader.onload = function(e) {
          previewImg.onload = function() {
            previewWrap.style.display = 'block';
            if (dropzone) dropzone.style.display = 'none';
            if (heading) heading.style.display = 'none';
            if (searchBtn) searchBtn.style.display = 'inline-block';
            if (reuploadBtn) reuploadBtn.style.display = 'inline-block';
            lastWindowWidth = window.innerWidth;
            resetCropToCenter();
            setStatus('Drag the box to the tile, or tap Find to search automatically.');
          };
          previewImg.src = e.target.result;
        };
        reader.readAsDataURL(file);
      }

      if (dropzone) {
        dropzone.addEventListener('click', function() { if (fileInput) fileInput.click(); });
        dropzone.addEventListener('dragover', function(e) { e.preventDefault(); dropzone.style.borderColor = '#ff6b00'; });
        dropzone.addEventListener('dragleave', function() { dropzone.style.borderColor = ''; });
        dropzone.addEventListener('drop', function(e) {
          e.preventDefault();
          dropzone.style.borderColor = '';
          var file = e.dataTransfer.files && e.dataTransfer.files[0];
          if (file) handleFile(file);
        });
      }

      if (browseBtn) {
        // Prevent this from also triggering the dropzone's own click
        // handler (the button sits inside the dropzone), which would
        // otherwise open the file picker twice.
        browseBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          if (fileInput) fileInput.click();
        });
      }

      if (fileInput) {
        fileInput.addEventListener('change', function() {
          var file = fileInput.files && fileInput.files[0];
          if (file) handleFile(file);
        });
      }

      // Ctrl+V / Cmd+V anywhere on the page pastes an image straight in,
      // matching the "or Ctrl V to paste" hint shown in the dropzone.
      document.addEventListener('paste', function(e) {
        var items = e.clipboardData && e.clipboardData.items;
        if (!items) return;
        for (var i = 0; i < items.length; i++) {
          if (items[i].type && items[i].type.indexOf('image') !== -1) {
            var file = items[i].getAsFile();
            if (file) {
              e.preventDefault();
              handleFile(file);
            }
            break;
          }
        }
      });

      if (searchBtn) {
        searchBtn.addEventListener('click', function() {
          if (userAdjustedCrop) {
            runManualSearch();
          } else if (currentFile) {
            runAutoSearch(currentFile);
          }
        });
      }

      if (reuploadBtn) {
        reuploadBtn.addEventListener('click', function() {
          if (fileInput) fileInput.click();
        });
      }
    }
  };
})();